<template>
<div>
  <table class="table">
    <tr>
      <th>
        Nazwa
      </th>
      <th>
        Typ
      </th>
      <th>
        Akcje
      </th>
    </tr>
    <tr v-for="item in items">
      <td>
        <a class="main-link" href="#" @click="$router.push({name: 'admin.templates.show', params: {id: item.id}})">{{ item.name }}</a>
      </td>
      <td>
        <span>{{ item.template_type }}</span>
      </td>

      <td class="actions">
        <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.templates.edit', params: {id: item.id}})">Edytuj</ui-button>
        <ui-button type="flat" icon="highlight_off" color="danger" @click.prevent="remove(item)">Usuń</ui-button>
      </td>
    </tr>
  </table>
  <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>
</template>

<script>
import Templates from './../../services/Templates'
import EventEmitter from './../../services/EventEmitter'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  data () {
    return {
      disabled: true,
      showConfirm: false
    }
  },
  methods: {
    getService () {
      return Templates
    },
    _remove (item) {
      Templates.remove(item.id).then((res) => {
        if (res.status === 204) {
          this.reload()
          this.notify('Usunięto')
        }
      })
    },
    remove (item) {
      EventEmitter.$emit('confirm.show', {
        confirmCb: () => {
          this._remove(item)
        }
      })
    }
  },
  mounted () {
    EventEmitter.$on('templates.reload', () => {
      this.meta.current_page = 1
      this.reload()
    })
  }
  // events: {
  //   'templates.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }
}

</script>


// WEBPACK FOOTER //
// List.vue?3970491d